import CustomReports from '../components/CustomReport';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';

export default function Dashboard() {
  return (
    <div className="bg-base-100 min-h-screen">
      <div className="md:mx-auto md:container">
        <Navbar />
        <div className="flex">
          <Sidebar />
          <main className="flex-1 p-4 pb-32 min-w-0 overflow-x-auto">
            <CustomReports />
          </main>
        </div>
      </div>
    </div>
  );
}
